import { anchorType, AnyString, assetType, DeviceType } from "types";

export const mapDeviceTypeToDisplay = (type: DeviceType | AnyString) => {
  switch (type) {
    case assetType.Physical:
      return "Physical";
    case assetType.Mobile:
      return "Mobile";
    case anchorType.Luna:
      return "Luna";
    case anchorType.Wifi:
      return "Wi-Fi";
    default:
      return type;
  }
};
